import React, { useEffect, useState } from 'react';
import Pagination from '../components/Pagination';
import { usePagination } from '../hooks/usePagination';
import { getAccessMatrix } from '../services/api';
import './AccessMatrix.css';

const AccessMatrix = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getAccessMatrix()
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleExport = () => {
    if (!data?.users) return;
    const rows = ['User,GitHub Username,Repository,Permission'];
    data.users.forEach((u) => {
      u.repos.forEach((r) => {
        rows.push(`"${u.username}","${u.githubUsername || ''}","${r.repoName}","${r.permission}"`);
      });
    });
    const blob = new Blob([rows.join('\n')], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'access-matrix.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const filtered = (data?.users || []).filter((u) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return (
      u.username?.toLowerCase().includes(term) ||
      u.githubUsername?.toLowerCase().includes(term) ||
      u.displayName?.toLowerCase().includes(term)
    );
  });

  const userPages = usePagination(filtered, 15, search);

  if (loading) return <div className="access-matrix-page"><div className="spinner" /></div>;

  return (
    <div className="access-matrix-page">
      <div className="access-matrix-header">
        <div>
          <h1>Access Matrix</h1>
          <p>{filtered.length} users with repository access across {data?.repoCount || 0} repos</p>
        </div>
        <button className="btn btn-secondary" onClick={handleExport}>Export CSV</button>
      </div>

      <input
        type="text"
        className="form-input access-matrix-search"
        placeholder="Search users..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="access-matrix-list">
        {filtered.length === 0 ? (
          <p className="empty-message">No access records found</p>
        ) : userPages.pageItems.map((user) => (
          <div key={user.userId} className="access-matrix-user card">
            <div className="access-matrix-user-header">
              <strong>{user.displayName || user.username}</strong>
              <span className="text-muted">@{user.githubUsername || user.username}</span>
              <span className="repo-count">{user.repos.length} repos</span>
            </div>
            <PagedRepos repos={user.repos} />
          </div>
        ))}
      </div>
      <Pagination
        page={userPages.page}
        totalPages={userPages.totalPages}
        total={userPages.total}
        pageSize={userPages.pageSize}
        onPageChange={userPages.setPage}
        label="users"
      />
    </div>
  );
};

function PagedRepos({ repos }) {
  const pages = usePagination(repos, 12, repos.length);
  return (
    <>
      <div className="access-matrix-repos">
        {pages.pageItems.map((r) => (
          <div key={r.repoId} className="access-matrix-repo">
            <span className="repo-name">{r.repoName}</span>
            <span className={`perm-badge perm-${r.permission}`}>{r.permission}</span>
          </div>
        ))}
      </div>
      <Pagination
        page={pages.page}
        totalPages={pages.totalPages}
        total={pages.total}
        pageSize={pages.pageSize}
        onPageChange={pages.setPage}
        label="repositories"
      />
    </>
  );
}

export default AccessMatrix;
